import React from "react"
import { motion } from "framer-motion"

const persitantVars = {
  open: {
    pointerEvents: "all",
    opacity: 1,
  },
  closed: {
    pointerEvents: "none",
    opacity: 0,
  },
}

export const PersistantModal = ({ isOpen, children }) => {
  return (
    <motion.div
      variants={persitantVars}
      initial="closed"
      animate={isOpen ? "open" : "closed"}
      transition={{ type: "spring", damping: 10 }}
      className="w-screen h-screen top-0 left-0 z-2000 fixed overflow-y-auto"
    >
      {children}
    </motion.div>
  )
}
